import React, { useState } from 'react';
import { Dialogs, Dialog, Popup, Flex, Text, Button, DateTimeRangePicker } from '@leverege/ui-elements';
import { ExportEditor, ExportModelCreatorFactory, Exporter } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import ApiServerItemIterator from "./iterators/ApiServerItemIterator.js";
import ApiServerHistoryItemIterator from "./iterators/ApiServerHistoryItemIterator.js";
import ExportSettingsEditor from "./ExportSettingsEditor.js";
import DataViewerCardModel from "../../dashboard/DataViewerCardModel.js";
import S from './ExportAction.css';
import HistoryViewModel from "../../history/models/HistoryViewModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.actions.ExportAction');
export default function ExportAction(molten, exportType) {
  return {
    id: `molten.export${exportType ? `.${exportType}` : ''}`,
    handles: context => {
      const {
        clientProps
      } = context;
      // const { objectType } = clientProps
      let {
        settings: model
      } = clientProps;
      model = model?.dataViewers?.[0]?.settings || model;
      const exportModel = ExportModelCreatorFactory.get(model);
      return exportModel != null;
    },
    layout: {
      sort: 'zzzz'
    },
    customComponent: function ExportActionComp({
      context
    }) {
      const api = molten.get('api');
      const {
        clientProps
      } = context;
      const {
        mobile,
        settingsPath,
        objectType,
        delegate,
        settings: model,
        relationship,
        filters,
        dashboardContext,
        dataViewerCardModel
      } = clientProps;
      const [opened, setOpened] = useState(false);
      const url = `v1/interface/${delegate.getUrl(true)}`;
      let exportModel;
      if (exportType === 'history') {
        const tableDataViewerModel = model?.dataViewers?.[1] || model?.dataViewers?.[0];
        exportModel = ExportModelCreatorFactory.create(tableDataViewerModel.settings, objectType);
      } else {
        exportModel = ExportModelCreatorFactory.create(model, objectType);
      }
      const onSave = ({
        value
      }) => {
        let iterator;
        if (exportType === 'history') {
          const needsDate = dataViewerCardModel && DataViewerCardModel.getNeedsDate(dataViewerCardModel);
          let range = needsDate ? dashboardContext?.options?.dateTimeRange : HistoryViewModel.getRange(model);
          range = DateTimeRangePicker.getRange(range);
          iterator = new ApiServerHistoryItemIterator({
            range,
            where: clientProps.exportWhere,
            objectType,
            delegate
          });
        } else {
          iterator = new ApiServerItemIterator({
            api,
            url,
            delegate,
            path: relationship.path,
            filters,
            ref: delegate.getInterfaceUrl(),
            objectType
          });
        }
        new Exporter(value).export(iterator);
        setOpened(false);
      };
      const openAdvanced = () => {
        Dialogs.show({
          component: props => {
            const {
              show,
              onClose,
              onSave: pOnSave
            } = props;
            const onSave = evt => {
              pOnSave(evt);
              onClose();
            };
            return /*#__PURE__*/_jsx(Dialog, {
              show: show,
              closeOnEscape: false,
              closeOnDocumentClick: false,
              onClose: onClose,
              children: /*#__PURE__*/_jsx(ExportSettingsEditor, {
                ...props,
                onSave: onSave
              })
            });
          },
          props: {
            editor: ExportEditor,
            settingsPath: `${settingsPath}.export`,
            versionsPath: `${objectType}.export`,
            title: t('editExportOptions'),
            editorProps: {
              objectType
            },
            value: exportModel,
            onSave
          }
        });
      };
      return /*#__PURE__*/_jsx(Popup, {
        className: S.popup,
        toggleVariant: mobile ? 'mobileActionBar' : 'actionBar',
        opened: opened,
        onChange: ({
          isOpened
        }) => setOpened(isOpened),
        icon: tIcon('exportIcon', 'fa fa-fw fa-download'),
        children: /*#__PURE__*/_jsx(ExportSettingsEditor, {
          simple: true,
          title: /*#__PURE__*/_jsxs(Flex, {
            align: "center",
            variant: "rowL",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: t('formTitle')
            }), /*#__PURE__*/_jsx(Button, {
              variant: "link",
              onClick: openAdvanced,
              children: t('link')
            })]
          }),
          onClose: () => setOpened(false),
          editor: ExportEditor,
          settingsPath: `${settingsPath}.export`,
          versionsPath: `${objectType}.export`,
          editorProps: {
            objectType
          },
          onSave: onSave,
          value: exportModel
        })
      });
    }
  };
}